<div class="p-8 border rounded-lg bg-card" [formGroup]="configForm">
    <div class="pb-4 border-b">
        <h2 class="text-xl font-semibold">Configuration</h2>
        <p class="mt-1 text-secondary">
            Enter your API key and select the languages for translation.
        </p>
    </div>

    <div class="mt-6 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-8">
        <!-- API Key -->
        <mat-form-field class="sm:col-span-2" [subscriptSizing]="'dynamic'">
            <mat-label>OpenRouter API Key</mat-label>
            <input matInput type="password" formControlName="apiKey" />
            <mat-error *ngIf="configForm.get('apiKey')?.hasError('required')">
                API Key is required.
            </mat-error>
        </mat-form-field>

        <!-- Model Selection -->
        <mat-form-field class="sm:col-span-1" [subscriptSizing]="'dynamic'">
            <mat-label>AI Model</mat-label>
            <mat-select formControlName="selectedModel">
                <mat-option *ngFor="let model of availableModels" [value]="model.id">
                    {{ model.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <!-- Base Language (Read-only) -->
        <div class="sm:col-span-1 p-2">
            <div class="text-sm text-gray-500">Base Language</div>
            <div class="mt-1 text-lg font-medium">English (en)</div>
        </div>

        <!-- Target Languages -->
        <div class="sm:col-span-2">
            <label class="text-base font-medium text-gray-900 dark:text-gray-100">
                Target Languages
            </label>
            <p class="text-sm leading-5 text-secondary">
                Select one or more languages to translate to.
            </p>

            <mat-checkbox
                class="mt-4 mb-2"
                [checked]="allLanguagesSelected"
                [indeterminate]="isIndeterminate"
                (change)="toggleSelectAll($event)">
                Select All
            </mat-checkbox>

            <mat-selection-list formControlName="targetLanguages">
                <mat-list-option *ngFor="let lang of targetLanguageOptions" [value]="lang.code">
                    {{ lang.label }} ({{ lang.code }})
                </mat-list-option>
            </mat-selection-list>
            <mat-error *ngIf="configForm.get('targetLanguages')?.touched && configForm.get('targetLanguages')?.hasError('required')">
                Please select at least one target language.
            </mat-error>
        </div>
    </div>

    <!-- Actions -->
    <div class="flex justify-end mt-8 pt-6 border-t">
        <button
            mat-flat-button
            color="primary"
            [disabled]="configForm.invalid"
            (click)="onNext()"
        >
            Next: Upload Files
        </button>
    </div>
</div>
